import {
  AppSettings,
  Audience,
  ComponentSettings,
  PrivacyPolicyType,
  Theme,
  Timestamp,
  TranslationsMap,
} from '../../types';
import axios from 'axios';
import { getInstanceForAuthorization } from '../instance-service/instance-service';
import { appDefIds } from '@wix/business-manager-api';

export const getComponentSettings = async (locale: string): Promise<ComponentSettings> => {
  const currentInstance = getInstanceForAuthorization();
  if (!currentInstance) {
    return {
      settings: {
        appEnabled: false,
        theme: Theme.light,
        privacyPolicyType: PrivacyPolicyType.PageOnSite,
        privacyPolicyPage: '',
        audience: Audience.AllVisitors,
      },
    };
  }

  const { languageCode } = getLanguageKey(locale);
  const result = await axios.get(
    `/_api/app-settings-service/v1/settings/components/${appDefIds.consentPolicyBanner}?languageKey.languageCode=${languageCode}&host=BUSINESS_MANAGER`,
    {
      headers: {
        Authorization: currentInstance,
      },
    },
  );

  return result.data;
};

export interface SetOptions {
  appSettings: Partial<AppSettings>;
}

export const setComponentSettings = async ({ appSettings }: SetOptions) => {
  await axios.patch(
    `/_api/app-settings-service/v1/settings/components/${appDefIds.consentPolicyBanner}`,
    {
      states: ['NR'],
      host: 'BUSINESS_MANAGER',
      settings: appSettings,
    },
    {
      headers: {
        Authorization: getInstanceForAuthorization(),
      },
    },
  );
};

interface LanguageKey {
  languageCode: string;
  region: string;
}

export const getLanguageKey = (locale: string): LanguageKey => {
  const split = locale.split('-');
  return {
    languageCode: split[0],
    region: split[1],
  };
};

export interface ComponentSettingsService {
  getComponentSettings(locale: string): Promise<ComponentSettings>;
  setComponentSettings(options: SetOptions): Promise<void>;
}

export const componentSettingsService: ComponentSettingsService = {
  getComponentSettings,
  setComponentSettings,
};
